var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "DefaultContentLayout",
        [
          _c(
            "div",
            [
              _c("ClientFilters", {
                attrs: {
                  currentUserId: _vm.currentUser.id,
                  currentUserRole: _vm.currentUser.role,
                  filters: _vm.projectFilters,
                  hideContractorsFilter: "",
                  hideBudgetFilter: "",
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  filtersReset: _vm.resetFilters,
                },
              }),
              _c(
                "h1",
                {
                  staticClass:
                    "font-semibold font-outfit leading-10 project-count mb-3",
                },
                [_vm._v(" " + _vm._s(_vm.draftTotal) + " Total draft visits ")]
              ),
            ],
            1
          ),
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: _vm.hasData,
                loading: _vm.isLoading,
                spinnerCentered: "",
              },
            },
            [
              _vm.empty
                ? _c("EmptyListPlaceholder", {
                    attrs: { title: _vm.emptyListPlaceholder, subtitle: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function () {
                            return [_c("EmptyListImageProjects")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4049957145
                    ),
                  })
                : [
                    _c("VisitsCardWrapper", {
                      attrs: {
                        activities: _vm.activities,
                        currentUser: _vm.currentUser,
                        companyId: _vm.company.id,
                      },
                      on: {
                        visitUpdated: _vm.refetchVisits,
                        projectUpdated: _vm.refetchVisits,
                      },
                    }),
                    _c("CardPagination", {
                      attrs: { config: _vm.paginationConfig },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm.dialog
        ? _c("ActivityFormModal", {
            attrs: {
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
            },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          draftTotal: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }